import { del, get, post, put } from "@/services/axiosUitils";

const basePath = "/city_collab/invite-codes";

class SettingService {
  getSetting = async (notifyMessage?: boolean): Promise<any> => {
    return await get(`${basePath}/`, { notifyMessage });
  };

  getSettingById = async (
    id: string,
    notifyMessage?: boolean
  ): Promise<any> => {
    return await get(`${basePath}/${id}/`, { notifyMessage });
  };

  createSetting = async (
    params: any,
    notifyMessage?: boolean
  ): Promise<any> => {
    return await post(`${basePath}/`, params, { notifyMessage });
  };

  updateSetting = async (
    id: string,
    params: any,
    notifyMessage?: boolean
  ): Promise<any> => {
    return await put(`${basePath}/${id}/`, params, { notifyMessage });
  };

  deleteSetting = async (id: string, notifyMessage?: boolean): Promise<any> => {
    return await del(`${basePath}/${id}/`, { notifyMessage });
  };

  // ✅ here is your method
  validateInviteToken = async (payload: any, notifyMessage = false) => {
    return await post(`${basePath}/verify/`, payload, { notifyMessage });
  };
}

export default new SettingService();
